import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import {
  hasAttemptedChunkRecovery,
  isChunkLoadError,
  recoverFromChunkLoadError
} from "@/shared/lib/chunkRecovery";

export function RouteErrorBoundary() {
  const error = useRouteError();
  const routeError = isRouteErrorResponse(error)
    ? (error as { error?: unknown }).error
    : error;
  const chunkError = isChunkLoadError(routeError) || isChunkLoadError(error);

  useEffect(() => {
    if (chunkError && !hasAttemptedChunkRecovery()) {
      recoverFromChunkLoadError();
    }
  }, [chunkError]);

  return (
    <main className="flex min-h-dvh items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <div className="mx-auto flex size-14 items-center justify-center rounded-full bg-danger/10 text-danger">
          <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h1 className="mt-4 text-lg font-semibold">
          {chunkError ? "Updating TailorBook…" : "Something went wrong"}
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {chunkError
            ? hasAttemptedChunkRecovery()
              ? "A new version is available. Reload TailorBook to continue."
              : "A new version is available. Refreshing the app now…"
            : "Your data is safe. Reload the app to continue."}
        </p>
        <button type="button" className="btn-primary mt-5" onClick={() => window.location.reload()}>
          Reload TailorBook
        </button>
      </div>
    </main>
  );
}
